import { ImageModel } from './image.model';
import { AddressModel } from './address.model';
import { SexEnum } from './sexEnum.model';
import { InputModel } from '../components/input/input.model';
import { RequiredModel } from '../components/input/rules/implementations/required.model';
import { CPFModel } from '../components/input/rules/implementations/cpf.model';
import { EmailModel } from '../components/input/rules/implementations/email.model';
import { AreaCodeModel } from '../components/input/rules/implementations/areaCode.model';
import { PhoneModel } from '../components/input/rules/implementations/phone.model';
import { StringUtils } from '../helpers/stringUtils';

export class UserModel {

  id: string;
  nome: string;
  foto: ImageModel = new ImageModel();
  cpf: string;
  endereco: AddressModel = new AddressModel();
  RG: string;
  codigoUnico: string;
  sexo: SexEnum;
  ddd: string;
  dataCriacao: string;
  dataNascimento: string;
  facebookId: string;
  pin: string;
  pinBloqueado: string;
  email: string;
  password: string;
  telefone: string;

  nameInputModel = new InputModel(false, false, 'text', 'Nome', [new RequiredModel()]);
  documentInputModel = new InputModel(false, false, 'tel', 'CPF', [new CPFModel()], new CPFModel());
  emailInputModel = new InputModel(false, false, 'email', 'E-mail', [new RequiredModel(), new EmailModel()]);
  dddInputModel = new InputModel(false, true, 'tel', 'DDD', [], new AreaCodeModel());
  phoneInputModel = new InputModel(false, true, 'tel', 'Celular', [], new PhoneModel());

  constructor() {
    this.documentInputModel.setReadOnly();
  }

  static fromJsonToUserModel(jsonUser): UserModel {
    const user = new UserModel();

    user.id = jsonUser.id;
    user.nome = jsonUser.nome;
    user.foto = jsonUser.foto;
    user.cpf = jsonUser.cpf;
    if (jsonUser.endereco) {
      user.endereco = AddressModel.fromJsonToAddress(jsonUser.endereco);
    }
    user.RG = jsonUser.RG;
    user.codigoUnico = jsonUser.codigoUnico;
    user.sexo = jsonUser.sexo;
    user.ddd = jsonUser.ddd;
    user.dataCriacao = jsonUser.dataCriacao;
    user.dataNascimento = jsonUser.dataNascimento;
    user.facebookId = jsonUser.facebookId;
    user.pin = jsonUser.pin;
    user.pinBloqueado = jsonUser.pinBloqueado;
    user.email = jsonUser.email;
    user.password = jsonUser.password;
    user.telefone = jsonUser.telefone;

    return user;
  }

  checkIfStillReadOnly(): any {
    if (!this.cpf) {
      this.documentInputModel.disableReadOnly();
    }
  }

  ableToRecharge(): boolean {
    return (!StringUtils.isNullOrEmpty(this.nome)
      && !StringUtils.isNullOrEmpty(this.cpf)
      && !StringUtils.isNullOrEmpty(this.email)
      && !StringUtils.isNullOrEmpty(this.ddd)
      && !StringUtils.isNullOrEmpty(this.telefone)
      && this.endereco.isComplete()
    );
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/user.model.ts